import { useFiltrosGlobales } from '@/lib/FiltrosGlobalesContext';
import { cliente } from '@/lib/cliente';
import type { PeriodoMaqSel } from '@/lib/cliente';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

/** Resumen mensual de utilización/ingreso por máquina. Alimenta el pivot. */
export function useMaquinariaUtilizacion(periodoMaq?: PeriodoMaqSel) {
  const { filtros } = useFiltrosGlobales();
  return useQuery({
    queryKey: ['maquinaria-utilizacion', filtros, periodoMaq],
    queryFn: () => cliente.maquinaria.utilizacion(filtros, periodoMaq),
    placeholderData: keepPreviousData,
  });
}
